import React from "react";

const Web3Wrapper = ({ children }) => {
  return children;
};

export default Web3Wrapper;
